import { ETroveStatusGraph } from '~components/hooks/protocol/_types';
import useVestaParametersData from '~components/hooks/protocol/useVestaParameters';
import { useAllVaultData } from '~components/hooks/protocol/vaults/useAllVaultData';
import { useVaultInterestRate } from '~components/hooks/protocol/vaults/useVaultInterestRate';
import { useVaultRewardAPR } from '~components/hooks/protocol/vaults/useVaultRewardAPR';
import useVaultUserData from '~components/hooks/protocol/vaults/useVaultUserData';
import { EVestaAsset } from '~config/types';

export const useDefaultVaultCard = (asset: EVestaAsset) => {
  const {
    data: { mcr, minNetDebt, vstMintCap },
    isLoading: isVestaParamsLoading,
  } = useVestaParametersData(asset);
  const {
    data: {
      vault: { status },
    },
    isLoading: isVaultUserLoading,
  } = useVaultUserData(asset);
  const { data: apr, isLoading: isAprLoading } = useVaultRewardAPR(asset);
  const {
    responses,
    computed: { isAnyVaultLoading },
  } = useAllVaultData();
  const { data: vrr, isLoading: isInterestLoading } = useVaultInterestRate(asset);

  return {
    mcr,
    apr,
    vrr,
    minimumBorrow: minNetDebt,
    mintCap: vstMintCap,
    vaultOpen: status !== ETroveStatusGraph.NULL && status !== ETroveStatusGraph.CLOSED_BY_OWNER,
    currentAssetDebt: Number(responses[asset].data.vault.currentAssetSystemState?.totalDebt || '0'),
    isVestaParamsLoading,
    isVaultUserLoading,
    isAprLoading,
    isAnyVaultLoading,
    isInterestLoading,
  };
};
